module.exports = __webpack_public_path__ + "images/interview-Uber-2.svg";